export default {"src":"/_next/static/media/people.0322c986.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};